import { render, staticRenderFns } from "./review-list-item.vue?vue&type=template&id=6c8dc6c3&"
import script from "./review-list-item.vue?vue&type=script&lang=js&"
export * from "./review-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports